import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const RemoveSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default RemoveSVG;
